import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Input, Form, notification } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import Breadcrumbs from '../components/Breadcrumbs';

const ServiceList = () => {
  const [services, setServices] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentService, setCurrentService] = useState(null);

  // Fetch data from API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('https://dashboard.arabicatech.vn/api/get-data-config-alert?id=ALL');
        const data = await response.json();

        console.log('data: ', data);

        if (Array.isArray(data.config)) {
          setServices(data.config);
        } else {
          console.error("Dữ liệu nhận được không phải là mảng");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []); // Empty dependency array ensures it runs once after component mounts

  // Log services after data has been set
  useEffect(() => {
    console.log('services: ', services); // This will log the updated services data
  }, [services]); // This will run every time the `services` state changes

  // Show Modal
  const showEditModal = (service) => {
    setCurrentService(service);
    setIsModalVisible(true);
  };

  // Handle modal ok (Update Service)
  const handleOk = async () => {
    try {
      // Gửi yêu cầu POST để cập nhật dịch vụ
      const response = await fetch('https://dashboard.arabicatech.vn/api/update-data-config-alert', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(currentService), // Gửi dữ liệu đã chỉnh sửa
      });

      const result = await response.json();
      console.log('API Response: ', result);

      if (result.errCode === 0) {
        // Nếu cập nhật thành công, cập nhật danh sách dịch vụ
        setServices((prevServices) =>
          prevServices.map((service) =>
            service.id === currentService.id ? currentService : service
          )
        );
        
        // Đóng modal
        setIsModalVisible(false);
        setCurrentService(null);
        
        // Hiển thị thông báo thành công
        notification.success({
          message: 'Update Successful',
          description: 'Config alert has been updated successfully!',
        });
      } else {
        console.error('Update error:', result.message);
        notification.error({
          message: 'Update Failed',
          description: result.message || 'An error occurred while updating.',
        });
      }
    } catch (error) {
      console.error('Error during update:', error);
      notification.error({
        message: 'Update Failed',
        description: 'There was an error while updating the service.',
      });
    }
  };

  // Handle modal cancel
  const handleCancel = () => {
    setIsModalVisible(false);
    setCurrentService(null);
  };

  // Handle input change inside modal
  const handleInputChange = (e, field) => {
    setCurrentService({
      ...currentService,
      [field]: e.target.value,
    });
  };

  // Table columns
  const columns = [
    {
      title: 'Service',
      dataIndex: 'service',
      key: 'service',
    },
    {
      title: 'Warning Threshold (%)',
      dataIndex: 'warning_threshold',
      key: 'warning_threshold',
    },
    {
      title: 'Average Revenue Days (day)',
      dataIndex: 'average_revenue_days',
      key: 'average_revenue_days',
    },
    {
      title: 'Check Frequency (h)',
      dataIndex: 'check_frequency',
      key: 'check_frequency',
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <Button
          icon={<EditOutlined />}
          onClick={() => showEditModal(record)}
        >
          Edit
        </Button>
      ),
    },
  ];

  return (
    <div>
      <Breadcrumbs data={["Config", "Config Alert"]} text={false} />
      <h2 style={{ color: 'rgb(0 0 0 / 68%)', fontSize: '24px', fontWeight: 'bold', margin: '0 0 20px' }}>Service List</h2>
      <Table
        columns={columns}
        dataSource={services}
        rowKey="id"
      />
      <Modal
        title="Edit Service"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Update"
        cancelText="Cancel"
      >
        {currentService && (
          <Form layout="vertical">
            <Form.Item label="Service Name">
              <Input
                value={currentService.service}
                onChange={(e) => handleInputChange(e, 'service')}
                disabled
              />
            </Form.Item>
            <Form.Item label="Warning Threshold (%)">
              <Input
                type="number"
                value={currentService.warning_threshold}
                onChange={(e) => handleInputChange(e, 'warning_threshold')}
              />
            </Form.Item>
            <Form.Item label="Average Revenue Days (day)">
              <Input
                type="number"
                value={currentService.average_revenue_days}
                onChange={(e) => handleInputChange(e, 'average_revenue_days')}
              />
            </Form.Item>
            <Form.Item label="Check Frequency (h)">
              <Input
                value={currentService.check_frequency}
                onChange={(e) => handleInputChange(e, 'check_frequency')}
              />
            </Form.Item>
          </Form>
        )}
      </Modal>
    </div>
  );
};

export default ServiceList;
